import { render } from "./UpdateStaffLoans.vue?vue&type=template&id=dac2b688"
import script from "./UpdateStaffLoans.vue?vue&type=script&lang=js"
export * from "./UpdateStaffLoans.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__